var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { userContentCss } from "./TaskEvents";
import { css } from "@emotion/css";
import { grey } from "@mui/material/colors";
import { useState } from "react";
import { ComposeInner } from "./Compose";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Description(props) {
    const [editing, setEditing] = useState(false);
    return /*#__PURE__*/ _jsxs("div", { className: descriptionCls, children: [/*#__PURE__*/ _jsx("div", { style: { fontWeight: "600", fontSize: "0.9rem" }, children: "Description" }), !editing && /*#__PURE__*/ _jsx("div", { className: clickableCss, onClick: e => {
                    var _e$target; // @ts-ignore
                    if (((_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.tagName) === "A") {
                        return;
                    }
                    e.stopPropagation();
                    e.preventDefault();
                    setEditing(true);
                }, children: /*#__PURE__*/ _jsx("div", { className: userContentCss, dangerouslySetInnerHTML: { __html: props.value || "<i>No description</i>" } }) }), editing && /*#__PURE__*/ _jsx(ComposeInner, { defaultValue: props.value, onSubmit: (value) => __awaiter(this, void 0, void 0, function* () { yield props.onUpdate(value); setEditing(false); }), onCancel: () => { setEditing(false); } })] });
}
const descriptionCls = css({ width: "100%", paddingLeft: 16, paddingRight: 16, paddingTop: 8 });
const clickableCss = css({ border: "1px solid " + grey["300"], borderRadius: 4, padding: 6, cursor: "pointer", "&:hover": { border: "1px solid " + grey["300"], backgroundColor: grey["300"] } });
